import { render, staticRenderFns } from "./DeleteAction.vue?vue&type=template&id=38720c9d&"
import script from "./DeleteAction.vue?vue&type=script&lang=js&"
export * from "./DeleteAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports